﻿$.fn.dxCtrlChartTitleEnvoi = function custom_dxCtrlChartTitleEnvoi(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcharttitleenvoi dx-ctrl");
        this.createInstance(new cdxCtrlChartTitleEnvoi(this, option));
    }
    return this;
}

// =====================================================================
// Résumé d'envoi partagé entre les instances : plusieurs contrôles peuvent afficher le même envoi
// (même id_table_com + id_com). Un seul appel getresumeenvoi à la fois par envoi, et le dernier résultat
// est réutilisé pendant DUREE_CACHE_MS (chaque instance relance toutes les 8 s, sans cela N instances = N appels).
// =====================================================================
if (!window.cdxCtrlChartTitleEnvoiPartage) window.cdxCtrlChartTitleEnvoiPartage = {}
window.cdxCtrlChartTitleEnvoiPartage.DUREE_CACHE_MS = 7000
window.cdxCtrlChartTitleEnvoiPartage.lst = {}
// force : ignore le résultat en cache (action de l'utilisateur : pause, annulation...) ;
// un appel déjà parti avant l'action est suivi d'un nouvel appel
window.cdxCtrlChartTitleEnvoiPartage.mCharger = function (bddCtrl, idTable, idCom, force, fnOk) {
    var P = window.cdxCtrlChartTitleEnvoiPartage
    var cle = (bddCtrl.nom_base || "") + "|" + idTable + "|" + idCom
    var e = P.lst[cle]
    if (!e) e = P.lst[cle] = { data: null, date: 0, enCours: false, relancer: false, lstFn: [] }
    if (!force && e.data && !e.enCours && (Date.now() - e.date) < P.DUREE_CACHE_MS) {
        fnOk(e.data)
        return
    }
    e.lstFn.push(fnOk)
    if (e.enCours) {
        if (force) e.relancer = true
        return
    }
    function mAppel() {
        e.enCours = true
        e.relancer = false
        var fini = false
        function mFin(data) {
            if (fini) return
            fini = true
            e.enCours = false
            if (e.relancer) { mAppel(); return }          // résultat peut-être antérieur à l'action : on recharge
            var lst = e.lstFn
            e.lstFn = []
            if (data) lst.forEach(function (fn) { try { fn(data) } catch (ex) { console.log(ex) } })
        }
        bddCtrl.mAjaxCall({
            command: "getresumeenvoi",
            id_table_com: idTable,
            id_com: idCom
        }, function (data) {
            var stat = data && data.stat ? data.stat[0] : null
            if (stat) { e.data = stat; e.date = Date.now() }
            mFin(stat)
        }, null, function () {
            mFin(null)                                      // erreur : les instances relanceront au prochain tour
        })
    }
    mAppel()
}

window.cdxCtrlChartTitleEnvoi = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        container.css({ "height": "100%", "width": "100%", "overflow": "hidden" })
        Me.mUpdate()
    }

    var progressBar = null;
    var dataLoaded = null
    var $TdObjet = null
    var $TdModif = null
    var $TdPause = null
    var $TdAnnule = null
    var $TdValue = null
    var $TableProgress = null
    var $DivDetailProgress = null
    var $DivCadencement = null
    var $TdProgressValue = null
    var $DivHyperReduit = null
    var $ImgJaugeHyperReduit = null
    var $ImgPauseHyperReduit = null
    function mRempli(data) {
        dataLoaded = data

        if (option.hyperReduit) {
            if ($DivHyperReduit == null) {
                //l'élément n'est pas créé
                container.css("display", "inline-block")
                container.css("border-radius", "5px")
                container.css("width", "45px")
                container.css("overflow", "hidden")
                container.css("text-overflow", "ellipsis")
                container.addClass("state-hover")
                var $DivJaugeHyperReduit = $("<div style='width:35px;height:35px;position:relative;display:block;'/>").appendTo(container)
                switch (option.bddCtrl.getObjet(option.data).mGetTable().nom) {
                    case "com_email_envoi":
                        $("<i class='fas fa-envelope' style='position:absolute;font-size:35px;top:0;left:0;opacity:0.6;'><i/>").appendTo($DivJaugeHyperReduit)
                        break;
                    case "com_sms_envoi":
                        $("<i class='fas fa-comment-sms' style='position:absolute;font-size:35px;top:0;left:0;opacity:0.6;'><i/>").appendTo($DivJaugeHyperReduit)
                        break;
                }
                //$("<img src='" + parametre.urldispatch + "/img/jauge2.svg' style='width:35px;position:absolute;top:0;left:0;'/>").appendTo($DivJaugeHyperReduit)
                $ImgJaugeHyperReduit = $("<i class='fas fa-spinner fa-spin-pulse dx-theme-accent-as-text-color' style='position:absolute;top:6px;left:6px;font-size:23px;display:none;'/>").appendTo($DivJaugeHyperReduit)
                $ImgPauseHyperReduit = $("<i class='fas fa-stop fa-beat dx-theme-accent-as-text-color' style='position:absolute;top:6px;left:9px;font-size:23px;display:none;'/>").appendTo($DivJaugeHyperReduit)
                var txt = parseInt(data.nb_dest - data.nb_attente) + "<span style='opacity:0.3'>/</span>" + data.nb_dest
                $DivHyperReduit = $("<div style='font-family:barlow condensed;text-align:center;font-size:95%;overflow:hidden;text-overflow:ellipsis;'>" + txt + "</div>").appendTo(container)
                txt = "<div>" + txt + "</div><u>" + option.data.email_expediteur + "</u>" + "<div>" + option.data.objet + "</div>"
                container.attr("title", txt)
                container.on("click", function () { option.bddCtrl.getObjet(option.data).mShowPopup() })
            }
        } else if ($TdPause == null) {
            //l'élément n'est pas créé
            var $Table = $("<table style='width:100%;font-family:barlow condensed;table-layout:fixed;'/>").appendTo(container)
            if (option.reduit) $Table.css("table-layout", "fixed")
            var $Tr = $("<tr/>").appendTo($Table)
            $TdObjet = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;'></td>").appendTo($Tr)
            if (parametre.isMobile) $Tr = $("<tr/>").appendTo($Table)
            $TdValue = $("<td style='width:327px;white-space:nowrap'/>").appendTo($Tr)
            if (option.reduit) $TdValue.css({
                "width": "140px",
                "text-align": "right"
            })
            var $Table = $("<table style='width:100%;font-family:barlow condensed;'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $TdProgress = $("<td style='width:100%'></td>").appendTo($Tr)
            $TableProgress = $("<table style='width:100%;'/>").appendTo($TdProgress)
            var $TrProgress = $("<tr/>").appendTo($TableProgress)
            $("<td style='width:29px;padding-right:5px;'><img src='" + parametre.urldispatch + "/img/jauge2.svg' style='width:27px;display:block'/></td>").appendTo($TrProgress)
            var $TdProgressBar = $("<td style='width:100%;vertical-align:middle;'/>").appendTo($TrProgress)
            progressBar = $("<div style='height:10px;'/>").appendTo($TdProgressBar).dxProgressBar({
                min: 0,
                max: parseInt(data.nb_dest),
                value: parseInt(data.nb_dest - data.nb_attente),
                width: "100%",
                showStatus: false
            }).dxProgressBar("instance");
            $TdProgressValue = $("<td style='width:1px;white-space:nowrap;'/>").appendTo($TrProgress)
            $DivDetailProgress = $("<div style='text-align:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;'/>").appendTo($TdProgress)
            $TdModif = $("<td style='width:40px;padding-left:5px;'></td>").appendTo($Tr)
            $TdPause = $("<td style='width:40px;padding-left:5px;'></td>").appendTo($Tr)
            $TdAnnule = $("<td style='width:40px;padding-left:5px;'></td>").appendTo($Tr)
            $DivCadencement = $("<div style='display:none'/>").appendTo(container)

            if (option.reduit) {
                $TdModif.remove()
                $TdPause.remove()
                $TdAnnule.remove()
                container.on("click", function () { option.bddCtrl.getObjet(option.data).mShowPopup() })
                container.addClass("state-hover")
                container.css("cursor", "pointer")
            } else {
                $TdValue.attr("colspan", "3")
            }

            $("<div/>").appendTo($TdModif).dxCtrlButton({
                height: 38,
                width: 38,
                icon: "fas fa-pen",
                txtTooltip: "Modifier le cadencement de vos envois",
                onClick: function (e) {
                    if ($DivCadencement.is(":visible")) {
                        $DivCadencement.slideUp(200, function () { $DivCadencement.empty() })
                    } else {
                        $DivCadencement.empty()
                        $("<div style='padding-top:15px;font-variant:small-caps;font-size:160%;'>Cadencement des envois</div>").appendTo($DivCadencement)
                        $("<table/>").appendTo($DivCadencement).dxCtrlConfigEnvoiCadencement({
                            bddCtrl: option.bddCtrl,
                            data: option.data,
                            showDateDebut: false
                        })
                        $DivCadencement.slideDown(200)
                    }
                },
                onContentReady: function (e) {
                    e.component.element().closest(".dxctrlbuttonenveloppe").css("border", theme.border)
                }
            })
            $("<div/>").appendTo($TdPause).dxCtrlButton({
                height: 38,
                width: 38,
                icon: ((data.pause_envoi == "1") ? "fas fa-play" : "fas fa-pause"),
                txtTooltip: ((data.pause_envoi == "1") ? "Envoi en pause<br/>Cliquez pour relancer" : "Envoi en cours<br/>Cliquez pour mettre en pause"),
                onClick: function (e) {
                    option.data.pause_envoi = ((option.data.pause_envoi == "1") ? "0" : "1")
                    option.bddCtrl.getObjet(option.data).mSaveChamp("pause_envoi", function () {
                        Me.mUpdate()
                    })
                    e.component.option("icon", "" + ((option.data.pause_envoi == "1") ? "fas fa-play" : "fas fa-pause") + " dx-theme-accent-as-text-color")
                    var dxBt = e.component.element().closest(".dx-ctrlbutton").getInstance()
                    dxBt.option("txtTooltip", ((option.data.pause_envoi == "1") ? "Envoi en pause<br/>Cliquez pour relancer" : "Envoi en cours<br/>Cliquez pour mettre en pause"))
                    if (option.data.pause_envoi == "1") { mNotify("Votre envoi va être mis en pause", "success", 6000) }
                    else { mNotify("Votre envoi va être relancé", "success", 6000) }
                },
                onContentReady: function (e) {
                    e.component.element().closest(".dxctrlbuttonenveloppe").css("border", theme.border)
                }
            })
            $("<div/>").appendTo($TdAnnule).dxCtrlButton({
                height: 38,
                width: 38,
                icon: "fas fa-ban",
                txtTooltip: "Annuler tous les envois restants<br/>en attente",
                onClick: function (e) {
                    var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                        target: $TdAnnule,
                        contentTemplate: function (contentElement) {
                            contentElement.css("padding", "20px")
                            $("<div>Votre envoi est en cours<br/>En annulant les envois,<br/>tous les envois des destinataires<br/>pour qui le message n'a pas été encore envoyé<br/>seront annulé<br/><br/>Les crédits non utilisé vous seront rendu.<br/><br/>Cette action est irréversible.</div>").appendTo(contentElement)
                            $("<br/>").appendTo(contentElement)
                            $("<div/>").appendTo(contentElement).dxCtrlButton({
                                text: "Annuler les envois restants",
                                onClick: function (e) {
                                    option.bddCtrl.mAjaxCall({
                                        command: "annulerenvoicomemailsmsenvoi",
                                        id_table_com: option.bddCtrl.getObjet(option.data).mGetTable().id_table,
                                        id_com: option.bddCtrl.getObjet(option.data).cle()
                                    }, function () {
                                        mNotify("Vous avez annulé l'envoi de votre message. Celui-ci va rapidement s'arrêter.", "success", 6000)
                                        option.bddCtrl.mReloadTable(["credit_sms", "credit_email"])
                                        Me.mUpdate()
                                    })
                                    tt.hide()
                                }
                            })
                        }
                    }).dxCtrlTooltip("instance")
                    tt.show()
                },
                onContentReady: function (e) {
                    e.component.element().closest(".dxctrlbuttonenveloppe").css("border", theme.border)
                }
            })
        }

        if (!option.hyperReduit) {
            $TdObjet.empty()
            var txt = ""
            switch (option.bddCtrl.getObjet(option.data).mGetTable().nom) {
                case "com_email_envoi":
                    txt = option.data.email_expediteur.decoupe() + "<br/>" + ((option.data.objet == null) ? "" : option.data.objet.reduit(25)) + ""
                    break;
                case "com_sms_envoi":
                    txt = ((option.data.emetteur == null) ? parametre.nom : option.data.emetteur) + "<br/>" + option.data.body_txt.reduit(25) + ""
                    break;
            }
            $TdObjet.html(txt)
            $TdObjet.attr("title", txt)

            if (option.data.date_fin_envoi_estime != null) {
                $("<br>").appendTo($TdObjet)
                if (option.data.date_fin_envoi_estime > parametre.dateNow) {
                    $("<span>Fin envois estimée: <i>" + option.data.date_fin_envoi_estime.toLocaleString("fr-FR", {
                        year: "2-digit",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit"
                    }).replace(",", "") + "</i></span>").appendTo($TdObjet)
                } else {
                    if (data.nb_attente > 0) {
                        var dat = new Date(parametre.dateNow)
                        dat = dat.addSecondes(data.nb_attente * 5)
                        $("<span>Fin envois estimée: <i>" + dat.toLocaleString("fr-FR", {
                            year: "2-digit",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit"
                        }).replace(",", "") + "</i></span>").appendTo($TdObjet)
                    } else {
                        $("<span>Dernier envoi le: <b>" + option.data.date_envoi.toFrenchDateTime() + "</b></span>").appendTo($TdObjet)
                    }

                }
            }


            if (parseInt(data.nb_attente) == 0) {
                if (option.reduit) {
                    container.slideUp(200, function () {
                        container.remove()
                        if (typeof option.onRemove != 'undefined') option.onRemove(Me)
                    })
                } else {
                    $TdModif.hide()
                    $TdPause.hide()
                    $TdAnnule.hide()
                    $TableProgress.hide()
                }
                $DivCadencement.empty()
            } else {
                progressBar.option({
                    min: 0,
                    max: parseInt(data.nb_dest),
                    value: parseInt(data.nb_dest - data.nb_attente)
                })
                $TdProgressValue.html(parseInt(data.nb_dest - data.nb_attente) + "<span style='opacity:0.3'>/</span>" + data.nb_dest)
            }
        }
        mRempliValue()
    }

    function mRempliValue() {
        if (option.hyperReduit) {
            var txt = parseInt(dataLoaded.nb_dest - dataLoaded.nb_attente) + "<span style='opacity:0.3'>/</span>" + dataLoaded.nb_dest
            $DivHyperReduit.html(txt)
            txt = "<div>" + txt + "</div><u>" + option.data.email_expediteur + "</u>" + "<div><b>" + option.data.objet + "</b></div>"
            if (option.data.pause_envoi == "1") {
                txt += "<div class='blinkscalealways'>MIS EN PAUSE PAR L'UTILISATEUR</div>"
                $ImgJaugeHyperReduit.hide()
                $ImgPauseHyperReduit.show()
            } else {
                txt += "<div><i class='fas fa-spinner fa-spin-pulse'></i>&nbsp;" + ((dataLoaded.nb_attente == 0) ? "" : ((dataLoaded.statut_txt.length == 0) ? "Envoi en cours" : dataLoaded.nb_envoi + " envoyés/" + dataLoaded.nb_dest + " &bull; " + dataLoaded.statut_txt)) + "</div>"
                $ImgJaugeHyperReduit.show()
                $ImgPauseHyperReduit.hide()
            }
            //container.attr("title", txt)
            if (container.attr("title").length == 0) {
                //le tooltip est affiché
            } else {
                container.attr("title", txt)
            }
        } else if (option.reduit) {
            $TdValue.css("font-size", "150%")
            var txtHtml = ""
            var txtHtml = "<span style=''>" + dataLoaded.nb_dest + "</span>&bull;"
            txtHtml += "<span style='color:gray'>" + dataLoaded.nb_envoi + "</span>"
            //txtHtml += "<span style='color:blue'>" + dataLoaded.nb_attente + "</span>&bull;"
            //if (dataLoaded.nb_listebounce > 0) txtHtml += "<span style='color:red'>" + dataLoaded.nb_listebounce + "</span>&bull;"
            //if (dataLoaded.nb_annule > 0) txtHtml += "<span style='color:brown;'>" + dataLoaded.nb_annule + "</span>&bull;"
            //txtHtml += "<span style='color:green'>" + (dataLoaded.nb_delivre) + "</span>&bull;"
            //txtHtml += "<span style='color:orange'>" + dataLoaded.nb_listenoire + "</span>"
            $TdValue.html(txtHtml)
            $TdValue.attr("title", txtHtml)
            // tooltip retiré : ne servait pas (et était recréé dans le body à chaque rafraîchissement)
            //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: container, position: "bottom", contentTemplate: function (contentElement) { mGetTableDetail().appendTo(contentElement) } }).dxCtrlTooltipHoverTarget("instance");
        } else {
            $TdValue.empty()
            $TdValue.css("font-size", "")
            mGetTableDetail().appendTo($TdValue)
        }
        if (!option.hyperReduit) {
            if (option.data.pause_envoi == "1") {
                $DivDetailProgress.text("MIS EN PAUSE PAR L'UTILISATEUR")
                $DivDetailProgress.addClass("blinkscalealways")
                $TdPause.addClass("blinkscalealways")
            } else {
                $DivDetailProgress.removeClass("blinkscalealways")
                $TdPause.removeClass("blinkscalealways")
                $DivDetailProgress.html(((dataLoaded.nb_attente == 0) ? "" : ((dataLoaded.statut_txt.length == 0) ? "Envoi en cours" : dataLoaded.nb_envoi + " envoyés/" + dataLoaded.nb_dest + " &bull; " + dataLoaded.statut_txt)))
            }
        }
    }

    function mGetTableDetail() {
        var $Table = $("<table style='width:100%;font-size:220%;text-align:center;font-family:barlow condensed;line-height:0.9;'/>")
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;white-space:nowrap;padding-right:5px;'><span style='font-size:50%'>Destinataire</span><br/>" + dataLoaded.nb_dest + "</td>").appendTo($Tr)
        var $Td = $("<td style='width:1px;white-space:nowrap;color:gray;padding-right:5px;'><span style='font-size:50%'>Envoyé</span><br/>" + dataLoaded.nb_envoi + "</td>").appendTo($Tr)
        if (dataLoaded.nb_attente > 0) {
            var $Td = $("<td style='width:1px;white-space:nowrap;color:blue;padding-right:5px;'><span style='font-size:50%'>Attente envoi</span><br/>" + dataLoaded.nb_attente + "</td>").appendTo($Tr)
        }
        var $Td = $("<td style='width:1px;white-space:nowrap;color:red;padding-right:5px;'><span style='font-size:50%'>Bounce</span><br/>" + dataLoaded.nb_listebounce + "</td>").appendTo($Tr)
        if (dataLoaded.nb_annule > 0) var $Td = $("<td style='width:1px;white-space:nowrap;color:brown;padding-right:5px;'><span style='font-size:50%'>Annulé</span><br/>" + dataLoaded.nb_annule + "</td>").appendTo($Tr)
        var $Td = $("<td style='width:1px;white-space:nowrap;color:green;'><span style='font-size:50%'>Délivré</span><br/>" + (dataLoaded.nb_delivre) + "</td>").appendTo($Tr)
        var $Td = $("<td style='width:1px;white-space:nowrap;color:orange;'><span style='font-size:50%'>Désincri.</span><br/>" + dataLoaded.nb_listenoire + "</td>").appendTo($Tr)
        return $Table
    }

    // mUpdate() : rechargement demandé (action de l'utilisateur) -> appel serveur, sans le cache partagé
    this.mUpdate = function (data) {
        if (typeof data == 'undefined') mCharger(true)
        else mRempli(data)
    }
    // force=false (rafraîchissement automatique) : résultat partagé avec les autres instances du même envoi
    function mCharger(force) {
        var objet = option.bddCtrl.getObjet(option.data)
        window.cdxCtrlChartTitleEnvoiPartage.mCharger(option.bddCtrl, objet.mGetTable().id_table, objet.cle(), force, function (data) {
            if (container.closest("body").length == 0) return   // contrôle retiré entre-temps
            mRempli(data)
        })
    }

    //lance une mise a jour interne auto
    //le composant est supprimé quand c'est fini
    this.mStartUpdate = function () {
        function mReload() {
            if (dataLoaded != null && dataLoaded.nb_attente == 0) {
                //le traitement est fini
                //tout est envoyé
                if (option.removeOnEnd) container.slideUp(200, function () {
                    container.remove()
                    if (typeof option.onRemove != 'undefined') option.onRemove(Me)
                })
            } else {
                if (container.closest("body").length == 0) return     // contrôle retiré : fin de la mise à jour
                // onglet caché : pas d'appel, on revérifie au prochain tour
                if (!document.hidden) mCharger(false)
                // envoi en pause : rien ne bouge, rafraîchi moins souvent
                var enPause = option.data.pause_envoi == "1" || (dataLoaded != null && dataLoaded.pause_envoi == "1")
                window.setTimeout(function () { mReload() }, enPause ? 30000 : 8000)
            }

        }
        mReload()
    }

    this.element = function () { return container }
    this.focus = function () { }

    mConstruit();
}